<template>
  <v-app>
    <template>
      <v-toolbar flat style="flex: none;">
        <v-toolbar-title>Đồng bộ CSDL Nông nghiệp</v-toolbar-title>
      </v-toolbar>
      <div class="tabs">
        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Dữ liệu OCOP</a>
        <a v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Dữ liệu sản phẩm trồng trọt</a>
        <a v-on:click="activetab=3" v-bind:class="[ activetab === 3 ? 'active' : '' ]">Dữ liệu sản phẩm chăn nuôi</a>
        <a v-on:click="activetab=4" v-bind:class="[ activetab === 4 ? 'active' : '' ]">Dữ liệu doanh nghiệp</a>
      </div>
      <v-divider/>
      <OcopDataList v-if="activetab==1" />
      <SpTrongTrotList v-if="activetab==2" />
      <SpChanNuoiList v-if="activetab==3" />
      <BusinessDataList v-if="activetab==4" />
    </template>
  </v-app>
</template>
<script>
  import OcopDataList from './OcopData.vue';
  import BusinessDataList from './BusinessData.vue';
  import SpTrongTrotList from './SpTrongTrot.vue';
  import SpChanNuoiList from './SpChanNuoi.vue';
  export default {
    components: { 
      OcopDataList,
      BusinessDataList,
      SpTrongTrotList,
      SpChanNuoiList
    },
    data: () => ({
      activetab: 1,
    })
  }
</script>
<style scoped>
  .tabs {
    overflow: hidden;
    margin-left: 20px;
    margin-bottom: -2px;
    z-index: 1;
  }
  .tabs ul {
    list-style-type: none;
    margin-left: 20px;
  }
  .tabs a{
    float: left;
    cursor: pointer;
    padding: 4px 24px;
    transition: background-color 0.2s;
    border: 1px solid #ccc;
    border-right: none;
    background-color: #f1f1f1;
    border-radius: 10px 10px 0 0;
    font-weight: bold;
  }
  .tabs a:last-child { 
    border-right: 1px solid #ccc;
  }
  .tabs a:hover {
    background-color: #aaa;
    color: #fff;
  }
  .tabs a.active {
    background-color: #fff;
    color: #484848;
    border-bottom: 2px solid #fff;
    cursor: default;
  }
</style>